var checkPhone = (rule, value, callback) => {
    const telReg = /^(400|800)(-)?[016789]\d{2}(-)?\d{4}$/g;
    const ghReg = /^\d{3,4}(-)?\d{7,8}$/g;
    const phoneReg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/g;
    if (!value) {
      return callback(new Error("电话号码不能为空"));
    }
    setTimeout(() => {
      if ((value.length>=11&&value.length<=16) || telReg.test(value) || phoneReg.test(value) || ghReg.test(value)) {
        callback();
      } else {
        callback(new Error("电话/手机号码格式不正确"));
      }
    }, 100);
};
const Rule = {
    "send.name": [
        {
          required: true,
          message: "请填写寄件人姓名",
          trigger: "blur",
        },
        {
          min: 1,
          max: 10,
          message: "姓名长度在 1到 10个字符",
          trigger: "blur",
        },
      ],
      "send.phone": [
        {
          validator: checkPhone,
          trigger: "blur",
        },
      ],
      "send.pca": [
        {
          required: true,
          message: "请选择省市区",
          trigger: "change",
        },
      ],
      "send.address": [
        {
          required: true,
          message: "请填写详细地址",
          trigger: "blur",
        },
        {
          min: 3,
          max: 39,
          message: "请填写详细地址，3-39个字之间",
          trigger: "blur",
        },
      ],
      "send.province": [
        {
          required: true,
          message: "省不能为空",
          trigger: "change",
        },
      ],
      "send.city": [
        {
          required: true,
          message: "市不能为空",
          trigger: "change",
        },
      ],
      "send.area": [
        {
          required: true,
          message: "区不能为空",
          trigger: "change",
        },
      ],
      "collect.name": [
        {
          required: true,
          message: "请填写收件人姓名",
          trigger: "blur",
        },
        {
          min: 1,
          max: 10,
          message: "姓名长度在 1到 10个字符",
          trigger: "blur",
        },
      ],
      "collect.phone": [
        {
          validator: checkPhone,
          trigger: "blur",
        },
      ],
      "collect.pca": [
        {
          required: true,
          message: "请选择省市区",
          trigger: "change",
        },
      ],
      "collect.province": [
        {
          required: true,
          message: "省不能为空",
          trigger: "change",
        },
      ],
      "collect.province_code": [
        {
          required: true,
          message: "省不能为空",
          trigger: "change",
        },
      ],
      "collect.city": [
        {
          required: true,
          message: "市不能为空",
          trigger: "change",
        },
      ],
      "collect.city_code": [
        {
          required: true,
          message: "市不能为空",
          trigger: "change",
        },
      ],
      "collect.area": [
        {
          required: true,
          message: "区不能为空",
          trigger: "change",
        },
      ],
      "collect.area_code": [
        {
          required: true,
          message: "区不能为空",
          trigger: "change",
        },
      ],
      "collect.address": [
        {
          required: true,
          message: "请填写详细地址",
          trigger: "blur",
        },
        {
          min: 3,
          max: 54,
          message: "详细地址需在3-54个字之间",
          trigger: "blur",
        },
      ],
}
export default Rule